module.exports = __webpack_public_path__ + "static/media/circle1.77e26dda.svg";